import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { ComplianceResponseModel } from '@/types/clarityLens'

export const getCompliance = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemName: string
): Promise<ComplianceResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/spend-lens/item/compliance`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        dcn: branchName,
        item_name: itemName,
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
